module.exports = {"id":"s6-q1c","text":"Are you comfortable using the device to complete course work?","multiselect":false,"next":"s6-q3","options":[{"id":"s6-q1c-a1","text":"Yes","capability":2,"access":0,"focusarea":[4,4,4,0,4]},{"id":"s6-q1c-a2","text":"No","capability":-2,"access":-3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s6-q1c.json
// module id = 916
// module chunks = 41